"use client";

import React from 'react';

/**
 * @deprecated Avoid using this context as this module is deprecated.
 */
export const CustomContext = React.createContext<any>(null);

/**
 * @deprecated Avoid using this context as this module is deprecated.
 */
export const CustomProvider = CustomContext.Provider;

/**
 * @deprecated Avoid using this context as this module is deprecated.
 */
export const useCustomContext = () => React.useContext(CustomContext);
